import _classCallCheck from "/var/www/riseup-pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/riseup-pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/www/riseup-pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/var/www/riseup-pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _extends from '../../polyfills/extends';
import React from 'react';
import data from '../../../data/all.json';
import NimblePicker from './nimble-picker';
import { PickerPropTypes } from '../../utils/shared-props';
import { PickerDefaultProps } from '../../utils/shared-default-props';
var Picker = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Picker, _React$PureComponent);
  var _super = _createSuper(Picker);
  function Picker() {
    _classCallCheck(this, Picker);
    return _super.apply(this, arguments);
  }
  _createClass(Picker, [{
    key: "render",
    value: function render() {
      return React.createElement(NimblePicker, _extends({}, this.props, this.state));
    }
  }]);
  return Picker;
}(React.PureComponent);
export { Picker as default };
Picker.propTypes /* remove-proptypes */ = PickerPropTypes;
Picker.defaultProps = _extends({}, PickerDefaultProps, {
  data: data
});